module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['vue-rqf-wrap', _vm.$route.name],
    staticStyle: {
      "display": "none",
      "background-image": "linear-gradient(to bottom, rgba(0,0,0,0) 30%,rgba(0,0,0,0.8) 100%),url(/wp-content/plugins/autotaksering/requests/assets/img/workshop.jpg)"
    },
    style: (_vm.$root.styleObject),
    attrs: {
      "id": "vue-request-quote-form"
    }
  }, [(!_vm.$root.ui.thanks) ? _c('div', [_c('div', {
    staticClass: "bg-loading",
    attrs: {
      "loading": _vm.$root.ui.loading
    }
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.$root.ui.modal.show) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.$root.ui.modal.show = false
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    domProps: {
      "textContent": _vm._s(_vm.$root.ui.modal.message)
    },
    slot: "header"
  })]) : _vm._e(), _vm._v(" "), (_vm.$root.ui.lightbox.show) ? _c('lightbox', {
    on: {
      "close": function($event) {
        return _vm.$root.hideUILightbox()
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/wp-content/plugins/autotaksering/requests/assets/img/fixtures/eksempel1.jpg"
    }
  })])])])]) : _vm._e()], 1) : _c('div', [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div thanks__container"
  }, [_c('div', {
    staticClass: "thanks__content eltdf-row-grid-section"
  }, [_c('div', {
    staticClass: "vc_column_container"
  }, [_c('div', {
    staticClass: "vc_column-inner"
  }, [_c('span', [_vm._v("Takk skal du ha.")]), _vm._v(" "), _c('span', [_vm._v("Vi har sendt forespørselen din og vil kontakte deg snart.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbf7ebce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/App.vue
// module id = 119
// module chunks = 0